// extracted by mini-css-extract-plugin
export default {"expense-overview":"ExpenseOverview_expense-overview__7nWKY"};